import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { TranslocoCurrencyPipe } from '@jsverse/transloco-locale';
import { BagItem } from '../../../../core/models';
import { MainService } from '../../../../core/services/main.service';
import { ExpoBagPage } from '../../../../core/enums';
import { PricePipe } from './../../../../core/pipes/price.pipe';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'expo-bag-item',
	standalone: true,
	imports: [TranslocoCurrencyPipe, PricePipe, RouterLink],
    templateUrl: './bag-item.component.html',
    styleUrls: ['./bag-item.component.css'],
})
export class ExpoBagItemComponent implements OnInit {

	@Input() item: BagItem;
	@Input() disableDecrement: boolean;
	@Input() expositionSlug: string;
	@Input() restaurantSlug: string;
	@Input() page: string;
	@Input() bagSize: number;

	showDecrementControl = true;
	showIncrementControl = true;
	isLoading: boolean = false;

	ExpoBagPage = ExpoBagPage;

	constructor(
		private mainService: MainService,
		public translate: TranslocoService
	) { }

	ngOnInit(): void { 
		if (this.page == 'checkout') this.page = ExpoBagPage.Checkout;
		else if (this.page == 'order') this.page = ExpoBagPage.Order;
		else this.page = ExpoBagPage.Menu;
	}

	incrementItem(item) {
		this.isLoading = true;
		this.mainService.incrementItem(this.mainService.expoBag, item).subscribe(_ => this.isLoading = false);
	}

	decrementItem(item) {
		this.isLoading = true;
		this.mainService.decrementItem(this.mainService.expoBag, item).subscribe(_ => this.isLoading = false);
	}

	isIncrementDisabled() {
		return this.isLoading;
	}

	isDecrementDisabled(item: BagItem, bagSize: number) {
		return this.isLoading || (bagSize != null && bagSize == 1 && item.quantity <= 1 && this.disableDecrement);
	}

}
